/**
 * Main Admin Interface
 *
 * React-based admin interface with routing for Added To Cart Popup.
 *
 * @since 1.0.0
 */

import { createRoot } from 'react-dom/client';
import { Router } from 'wouter';
import { useHashLocation } from 'wouter/use-hash-location';

import { AddedToCartPopupApp } from './components/added-to-cart-popup-app';
import { AdminContainer } from './styled';

/**
 * Initialize the admin interface
 *
 * @since 1.0.0
 */
const initializeAdmin = (): void => {
  const container = document.getElementById('redfox-added-to-cart-popup-root');

  if (!container) {
    return;
  }

  const root = createRoot(container);

  root.render(
    <AdminContainer>
      <Router hook={useHashLocation}>
        <AddedToCartPopupApp />
      </Router>
    </AdminContainer>
  );
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAdmin);
} else {
  initializeAdmin();
}
